<template>
  <!-- viewer product list -->
  <div class="modal-body">
    <ul class="status_step">
      <li>
        <span class="heading">{{ $t('sellYourProduct') }}</span>
        <span class="subHeading">{{ $t('inspireViewer') }}</span>
      </li>
      <li>
        <span class="heading">{{ $t('earnOnClick') }}</span>
        <span class="subHeading">{{ $t('earnMPoint') }}</span>
      </li>
      <!-- <li>
          <img src="../assets/images/live_default.png" />
        </li> -->
    </ul>
    <div class="goto_live">
      <h3 class="heading">{{ $t('clickToliveItem') }}</h3>
      <ul class="goto_live_list">
        <li
          v-if="productlist.length > 0"
          class="item_row"
          v-for="(data, key) in productlist"
        >
          <div class="list">
            <img :src="data.itemImage || data.displayImage" />
            <p class="item_description">
              {{ data.itemName || data.productName }}
            </p>
            <span class="selled_product"
              >{{
                orderIdview === data.ordered_id
                  ? viewClicked
                  : data.view || data.viewersCount
              }}{{ $t('boughtthisdeal') }}</span
            >
            <ul class="price_detail">
              <li>
                <span class="price_text">{{ $t('saleprice') }}</span>
                <span class="sell_price"
                  >₹ {{ data.totalPaidAmount || data.sellingPrice }}</span
                >
              </li>
              <!-- <li>
                <span class="price_text">आपका कमीशन:</span>
                <span class="commision">₹ {{data.sellingPrice}}</span>
              </li> -->
            </ul>
          </div>
          <div class="golive_button">
            <button
              class="btn-red"
              @click="uncheckedPrdt(key, data.ordered_id, data.saleReferenceID)"
            >
              {{ $t('makeLive') }}
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
export default {
  name: 'BroadCasterProductList',
  props: ['channel', 'xAuthId'],
  data() {
    return {
      productlist: [],
      activePrdt1: false,
      selectedInex: 0,
      shoppingActive: false,
      viewClicked: '',
      orderIdview: '',
      isLoading: false,
      orderId: '',
      noLive: false
    }
  },
  mounted() {
    this.productlist =
      this.$store.state && this.$store.state.broadCastProductList
    console.log(
      '------===this.$store.state && this.$store.state.broadCastProductList===---list vue-',
      this.$store.state && this.$store.state.broadCastProductList
    )
  },
  methods: {
    uncheckedPrdt(index, orderId, saleReferenceID) {
      console.log(
        '====--this.$store--',
        this.$store.state,
        orderId,
        saleReferenceID
      )
      this.selectedInex = index
      let obj = {
        room_id: this.channel,
        x_auth_id: this.xAuthId
      }
      if (!orderId) {
        obj.saleReferenceID = saleReferenceID
        // this.orderId = saleReferenceID
      } else {
        obj.ordered_id = orderId
        // this.orderId = orderId
      }
      console.log('---=obj=---', obj)
      // this.shoppingActive = false
      this.$socket.emit('broadcaster_live_product', obj)
      this.$emit('livedProduct')
    }
  },
  sockets: {
    // broadcaster_ordered_history: function(data) {
    //   console.log('==-data-==broadcaster_ordered_history---', data)
    //   // if (data.data.length > 0) {
    //   //   this.noLive = false
    //   //   this.$store.commit('broadCastProductList', data.data)
    //   //   this.productlist =
    //   //     this.$store.state && this.$store.state.broadCastProductList
    //   //   this.$store.commit('noLive', this.noLive)
    //   // } else {
    //   //   this.noLive = true
    //   //   this.$store.commit('noLive', this.noLive)
    //   // }
    //   // if (this.productlist.length > 0) this.shoppingActive = true
    // },
    view: function(data) {
      this.viewClicked = data.view
      this.orderIdview = data.ordered_id
    },
    new_live_product: function(data) {
      console.log('=---data-=', data)
      this.$toast.top('New Product has been live')
      this.shoppingActive = true
      this.$emit('true')
      this.$store.commit('broadCastProductListLive', data.data)
      console.log(
        '===--this.$store.state.broadCastProductListLive-=',
        this.$store.state.broadCastProductListLive
      )
      this.viewerProductList = data.data
    }
  }
}
</script>
